import methods from '@/services/methods'

export default {
  webhooksList () {
    return methods.sendGet('webhooks', null, {unprivilege: 'Settings', noHyptoLoader: true})
  },
  testWebhook (payload) {
    return methods.sendPost('webhooks/test', payload)
  },
  configureWebhook (payload) {
    return methods.sendPost('webhooks', payload, {disableButtons: true})
  },
  updateWebhook (category, payload) {
    return methods.sendPut(`webhooks/${category}`, payload, {disableButtons: true})
  },
  disableWebhook (category) {
    return methods.sendGet(`webhooks/${category}/disable`, null, {disableButtons: true})
  },
  enableWebhook (category) {
    return methods.sendGet(`webhooks/${category}/enable`, null, {disableButtons: true})
  }
}
